import type { FaxLetterCategory } from "../api/postCall/faxLetter";

export interface CategoryTag {
  label: string;
  backgroundColor: string;
  textColor: string;
}

const APPROVED_TAG = {
  backgroundColor: "#E6F3F0",
  textColor: "#005D49",
};
const DENIED_TAG = { backgroundColor: "#FFE8E8", textColor: "#CC0300" };
const NAR_TAG = { backgroundColor: "#EBFFFF", textColor: "#007A7A" };
const OTHERS_TAG = { backgroundColor: "#EAF2FF", textColor: "#0056D6" };

const CATEGORY_TAGS: Record<FaxLetterCategory, CategoryTag> = {
  approval: { label: "Approved", ...APPROVED_TAG },
  denial: { label: "Denied", ...DENIED_TAG },
  no_auth_required: { label: "NAR", ...NAR_TAG },
  additional_info_p2p: {
    label: "Additional Info / P2P",
    ...OTHERS_TAG,
  },
  unable_to_process: {
    label: "Unable to Process",
    ...OTHERS_TAG,
  },
  renewal: { label: "Renewal", ...OTHERS_TAG },
  others: { label: "Others", ...OTHERS_TAG },
  unclassified: { label: "Unclassified", ...OTHERS_TAG },
};

/**
 * The status tag for a category; an unknown value falls back to the shared "Others" styling.
 *
 * @param category - The letter's category for the J-code
 * @returns Tag label and colors
 */
export const getCategoryTag = (category: FaxLetterCategory): CategoryTag =>
  CATEGORY_TAGS[category] ?? { label: String(category), ...OTHERS_TAG };
